var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"navitem",class:{ active: _vm._active }},_vm.listeners),[_vm._t("default"),_c('div',{attrs:{"id":"navitem-notch"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }